'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var TextArea = require('@narvar/nth-block-text-area');
var Checkbox = require('@narvar/nth-block-checkbox');
var ItemAdditionalInfoProvider = require('../ItemAdditionalInfoProvider.js');
var Box = require('../../../components/layout/Box/Box.js');
var Typography = require('../../../components/Typography.js');
var ItemAdditionalInfoForm_module = require('./ItemAdditionalInfoForm.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var TextArea__default = /*#__PURE__*/_interopDefaultLegacy(TextArea);
var Checkbox__default = /*#__PURE__*/_interopDefaultLegacy(Checkbox);

const ItemAdditionalInfoForm = () => {
  const {
    commentHelper,
    commentLabel,
    confirmationLabel,
    itemClaimStep,
    confirmationChecked,
    onConfirmationChange,
    comment,
    onCommentChange
  } = ItemAdditionalInfoProvider.useItemAdditionalInfo();
  const {
    fields
  } = itemClaimStep;
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, fields.confirmation.show && /*#__PURE__*/React__default["default"].createElement(Checkbox__default["default"], {
    id: "confirmation",
    onChange: onConfirmationChange,
    checked: confirmationChecked
  }, confirmationLabel), fields.comment.show && /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 2
  }, /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: "comment"
  }, /*#__PURE__*/React__default["default"].createElement(Typography.BodyTextDefault, {
    s: {
      fontWeight: 'bold'
    }
  }, commentLabel)), /*#__PURE__*/React__default["default"].createElement(TextArea__default["default"], {
    id: "comment",
    placeholder: commentHelper || '',
    value: comment,
    onChange: onCommentChange,
    animateLabel: true,
    maxLength: 150,
    className: ItemAdditionalInfoForm_module["default"].textarea
  })));
};

exports["default"] = ItemAdditionalInfoForm;
